import { gql } from "apollo-angular"
export var get_company_event_dates = gql`
query companyEventDates($start: Date!, $end: Date!){
  companyEventDates(start_date: {to: $start, from: $end}){
    id
    start_date
    end_date
    start_time
    end_time
    timezone
    initial_date_time
    companyEvent{
      title
      id
      is_sponsored
      is_cancelled
      is_postponed
      is_cosponsored
      cosponsor
      sponsorship_amount
      companyEventType{
        name
      }
      companyEventAttendees{
        person {
          id
          name
          user {
            active
          }
        }
        is_registered
        id
      }
      companyEventFiles {
        id
        path
        drivePath {
          type
          path
        }
      }
      companyEventWebAddresses {
        webAddress {
          protocol
          subdomain
          domain
          tld
          path
          parameters
        }
      }
      companyEventAddresses{
        name
        address {
          id
          address1
          address2
          zipCode {
            zipcode
            city
            state {
              abbreviation
            }
          }
        }
      }
    }
  }
  me {
    permissionsForResource(resourceType: COMPANYEVENT){
      _read
      _delete
      _edit
      _create
    }
  }
  outlookEventTypes: outlook_event_type_by_typename(type: "Company Events"){
    id
    outlookEventTypePreference {
      id
      attendee_type
      outlookCalendar {
        id
        calendar_id
        user_id
      }
    }
    type
  }
}
`

export var get_company_event = gql`
    query getCompanyEvent($id: ID!){
      company_event(id: $id){
        title
        is_sponsored
        sponsorship_amount
        is_cancelled
        is_postponed
        is_cosponsored
        notes
        cosponsor
        companyEventAttendees {
          person {
            id
            name
            user {
              active
            }
          }
          is_registered
          id
        }
        companyEventAddresses{
          id
          name
          address_id
          address {
            id
            address1
            address2
            zipCode {
              zipcode
              city
              state {
                abbreviation
              }
            }
          }
        }
        companyEventDates{
          id
          start_date
          end_date
          start_time
          end_time
          timezone
          initial_date_time
        }
        companyEventWebAddresses {
          id
          name
          companyEvent{
            id
          }
          webAddress {
            id
            protocol
            subdomain
            domain
            tld
            path
            parameters
          }
        }
        companyEventFiles {
          path
          drivePath{
            path
          }
          id
        }
        companyEventType {
          name
          id
        }
        creaOutlookEvents {
          id
          companyEvent {
            id
          }
          outlookEvent {
            id
            event_id
          }
        }
      }
      outlookEventTypes: outlook_event_type_by_typename(type: "Company Events"){
        id
        outlookEventTypePreference {
          id
          attendee_type
          outlookCalendar {
            id
            calendar_id
            user_id
          }
        }
        type
      }
      me {
        permissionsForResource(resourceType: COMPANYEVENT){
          _create
          _edit
          _delete
          _read
        }
      }
    }
`

export var get_company_event_types = gql`
    query companyEventTypes{
      company_event_types {
        id
        name
      }
    }
`

export var get_all_company_events = gql`
    query company_events{
      company_events {
        id
        title
      }
    }
`

export var search_company_events = gql`
    query search_company_events(
      $searchLike: String!
      $search: String!
      $limit: Int!
    ){
      search_company_events(
        first: $limit
        title: $searchLike
        orderByInstr: [{ column: TITLE, search: $search, order: ASC }]
      ){
        data {
          id
          title
          companyEventType {
            name
          }
          companyEventDates{
            start_date
            end_date
            start_time
            end_time
            initial_date_time
          }
        }
      }
    }
`

export var search_active_employees = gql`
  query search_active_users($search: String!){
    search_active_users(
      name: $search
    ){
      name
      id
      entity {
        entity_types {
          id
          type {
            id
            name
            tagType {
              id
              name
            }
          }
        }
      }
      user {
        active
      }
    }
  }
`

export var get_employee_users = gql`
    query getActiveUsers{
      get_active_users {
        name
        id
      }
    }
`




